import FollowCollectionList from "./follow-collection-list";

export default FollowCollectionList;